module.exports = __webpack_public_path__ + "img/ad.a0c1f251.jpg";